// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"ec71e471","112":"b7bc7a6a","509":"d3fa1445","538":"7502cfce","614":"2e5d6e5f","980":"6ccffa7c"}[chunkId] + ".chunk.js";
};